// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Convenios_containerPrincipal__yPnze","divPrincipal":"Convenios_divPrincipal__khs7S","divTextos":"Convenios_divTextos__hqKQj"};